import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShredder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shredder, permanently"} maskId="square-filled-radius-0-stroke-1-IconShredder"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V10H4V2ZM2 12H22V13H2V12ZM6 15V20H5V15H6ZM10.3333 15V22H9.33333V15H10.3333ZM14.6667 15V20H13.6667V15H14.6667ZM19 15V22H18V15H19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShredder;
